import { css } from "styled-components/macro";

export const testOrderSecondaryCss = css`
  font-family: light;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  margin-top: -4px;
  color: ${({ theme }) => theme.testOrderSecondaryText};
`;
